export default "__VITE_ASSET__BMshxc4e__"